import crud from './helpers/crud';
import Promise from 'bluebird';
import { servletPost, servletSave } from './helpers';
import join from 'url-join';

export default class ProcessedGameDataDAO extends crud {
  constructor(urls) {
    super(urls.PROCESSED_GAME_DATA);
    this.PROCESSED_GAME_DATA = urls.PROCESSED_GAME_DATA;
  }

  commit(gameDataId) {
    if (typeof gameDataId !== 'string') {
      return Promise.reject(new Error('Invalid game ID'));
    }
    return servletSave(join(this.PROCESSED_GAME_DATA, gameDataId, 'save'), null);
  }

  update(id) {
    if (typeof id !== 'string') {
      return Promise.reject(new Error('Invalid ID provided'));
    }
    const url = join(this.PROCESSED_GAME_DATA, id, 'save');
    return servletPost(url);
  }
}


// WEBPACK FOOTER //
// ./src/js/util/dao/ProcessedGameDataDAO.js